import React from 'react';
import PropTypes from 'prop-types';
import ReactPinField from 'react-pin-field';
import './styles.scss';

function PinCodeInput({
    handlePinCodeChange,
    numberOfFields = 4,
    classNameCustom,
    classNameContainerCustom = '',
    profileWithCodePin = false,
    isFetching,
    isDisabled,
    cleanUpHanlderClosure,
    validateFormat = /^[a-zA-Z0-9]$/
}) {

    const inputRef = React.useRef(null);

    const focusOnTheFirst = () => inputRef?.current && inputRef.current[0]?.focus()

    const clearInputValue =  () => inputRef?.current?.forEach(input => (input.value = null))

    React.useEffect(() => focusOnTheFirst(), [isFetching, profileWithCodePin, isDisabled]);

    React.useEffect(()=>{
        cleanUpHanlderClosure && cleanUpHanlderClosure(clearInputValue)
    },[cleanUpHanlderClosure])

    return (
        <div className={`pinCodeInputContainer ${classNameContainerCustom}`}>
            <ReactPinField
                ref={inputRef}
                onChange={handlePinCodeChange}
                validate={validateFormat}
                length={numberOfFields}
                placeholder={profileWithCodePin ? '*' : ''}
                className={`pin-field ${classNameCustom}`} 
                {...(isDisabled ? {disabled: true} : {})}
            />
        </div>

    )
}

PinCodeInput.propTypes = {
    handlePinCodeChange: PropTypes.func,
    numberFields: PropTypes.number,
    classNameCustom: PropTypes.string,
    profileWithCodePin: PropTypes.bool,
    isFetching: PropTypes.bool
};

export default React.memo(PinCodeInput);